export default "__VITE_ASSET__CoIVpYk$__"